/* WattWheelz V50 — lightweight fixed-deadline seasonal countdown engine.
   Intentionally avoids document-wide MutationObserver so Shopify app blocks
   (Affirm/Klaviyo/etc.) can mount without countdown rescans. */
(function () {
  'use strict';

  var activeTimers = new WeakMap();

  function parseDeadline(raw) {
    if (!raw) return NaN;
    var ts = Date.parse(raw);
    return Number.isFinite(ts) ? ts : NaN;
  }

  function setAmount(timer, selector, value) {
    var node = timer.querySelector(selector);
    if (node) node.textContent = String(value).padStart(2, '0');
  }

  function stopTimer(timer) {
    var id = activeTimers.get(timer);
    if (id) window.clearInterval(id);
    activeTimers.delete(timer);
  }

  function updateTimer(timer) {
    var deadline = parseDeadline(timer.getAttribute('data-deadline'));
    if (!Number.isFinite(deadline)) {
      timer.setAttribute('data-countdown-error', 'invalid-deadline');
      return false;
    }

    var diff = deadline - Date.now();
    var root = timer.closest('[data-ww-event]');

    if (diff <= 0) {
      setAmount(timer, '[data-days]', 0);
      setAmount(timer, '[data-hours]', 0);
      setAmount(timer, '[data-minutes]', 0);
      setAmount(timer, '[data-seconds]', 0);
      if (root) root.classList.add('is-ended');
      timer.removeAttribute('data-countdown-running');
      return false;
    }

    if (root) root.classList.remove('is-ended');

    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);

    setAmount(timer, '[data-days]', days);
    setAmount(timer, '[data-hours]', hours);
    setAmount(timer, '[data-minutes]', minutes);
    setAmount(timer, '[data-seconds]', seconds);
    timer.setAttribute('data-countdown-running', 'true');
    return true;
  }

  function startTimer(timer) {
    if (!timer || activeTimers.has(timer)) return;

    if (!updateTimer(timer)) return;

    var id = window.setInterval(function () {
      if (!document.documentElement.contains(timer) || !updateTimer(timer)) {
        stopTimer(timer);
      }
    }, 1000);

    activeTimers.set(timer, id);
  }

  function initCountdowns(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;

    if (context.matches && context.matches('[data-ww-event-countdown]')) {
      startTimer(context);
    }

    context.querySelectorAll('[data-ww-event-countdown]').forEach(startTimer);
  }

  function boot() {
    initCountdowns(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  /* Shopify Theme Editor replaces individual sections. Initialize only the
     section Shopify tells us was reloaded, rather than observing the whole DOM. */
  document.addEventListener('shopify:section:load', function (event) {
    initCountdowns(event.target);
  });

  /* Safe hooks for theme-controlled async UI. They are no-ops unless emitted. */
  document.addEventListener('ww:cart:updated', function (event) {
    initCountdowns(event.target || document);
  });
  document.addEventListener('ww:drawer:opened', function (event) {
    initCountdowns(event.target || document);
  });
})();
